// ? : Feature flag manager to store flags accessible outside React components during initialization (immediately upon app start)
let isAgencyMarketingKrakendEnable = false;
let isKeycloakLoginWithSso = false;

export const featureFlagManagerForInitialization: {
  setIsKeycloakLoginWithSso: (value: boolean) => void;
  getIsKeycloakLoginWithSso: () => boolean;
  setIsAgencyMarketingKrakendEnable: (value: boolean) => void;
  getIsAgencyMarketingKrakendEnable: () => boolean;
} = {
  setIsKeycloakLoginWithSso: (value: boolean) => {
    isKeycloakLoginWithSso = value;
  },
  getIsKeycloakLoginWithSso: () => {
    return isKeycloakLoginWithSso;
  },
  setIsAgencyMarketingKrakendEnable: (value: boolean) => {
    isAgencyMarketingKrakendEnable = value;
  },
  getIsAgencyMarketingKrakendEnable: () => {
    return isAgencyMarketingKrakendEnable;
  },
};

export default featureFlagManagerForInitialization;
